import React from 'react'
import {Grid, Segment} from "semantic-ui-react";
import SignupForm from "../forms/SignupForm";

const Signup = () => {


  return (
    <Grid centered columns={1}>
      <Grid.Row>
        <Grid.Column>
          <Segment>
            <SignupForm/>
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
};

export default Signup